<template>
  <div class="fc-notice">
    <div class="fc-notice__container">
      <h1 class="fc-notice__title" v-if="title">
        <template v-for="(v, index) in stringParser(title)"> {{ v }}<br :key="index" /> </template>
      </h1>
      <div class="fc-notice__subtitle" v-if="subtitle">
        <template v-for="(v, index) in stringParser(subtitle)"> {{ v }}<br :key="index" /> </template>
      </div>
      <button class="fc-notice__button" v-if="buttonText" @click="confirm">{{ buttonText }}</button>

      <div class="fc-notice__text" v-if="cancelButtonText" @click="cancel">{{ cancelButtonText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'notice',
  props: ['title', 'subtitle', 'buttonText', 'cancelButtonText'],
  methods: {
    close() {
      this.$emit('close');
    },
    stringParser(s) {
      return s.split('\n');
    },
    confirm() {
      this.close();
      this.$emit('confirm-callback');
    },
    cancel() {
      this.$emit('callback');
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@fastcampus/styles/style.scss';
.fc-notice {
  width: 100%;
  margin: 2rem;
  &__container {
    padding: 4rem 2.4rem;
    border-radius: 0.6rem;

    background: #fff;
  }
  &__title {
    padding-bottom: 1.2rem;

    font-weight: bold;
    font-style: normal;
    font-size: 2rem;
    color: #2e2e2e;
    line-height: 3rem;
    text-align: center;
  }
  &__subtitle {
    font-weight: normal;
    font-style: normal;
    font-size: 1.6rem;
    color: #2e2e2e;
    line-height: 2.4rem;
    text-align: center;
    word-break: break-all;
  }
  &__button {
    width: 100%;
    margin: 2.4rem 0;
    padding: 1.4rem;
    border-radius: 0.4rem;

    background: #ed234b;

    font-weight: bold;
    font-style: normal;
    font-size: 1.6rem;
    color: #fff;
    line-height: 2.4rem;
    text-align: center;
  }
  &__text {
    font-weight: normal;
    font-style: normal;
    font-size: 1.4rem;
    color: #919191;
    line-height: 2.2rem;
    text-align: center;

    cursor: pointer;
    text-decoration-line: underline;
  }
  @include mq($from: small) {
    width: auto;
    &__container {
      box-sizing: border-box;
      max-width: 36rem;
    }
  }

  @include mq($until: x-small) {
    &__container {
      padding: 4rem 2.15rem;
    }
  }
}
</style>
